import { render } from "./createReserveComponent.vue?vue&type=template&id=622bb34e&scoped=true"
import script from "./createReserveComponent.vue?vue&type=script&lang=js"
export * from "./createReserveComponent.vue?vue&type=script&lang=js"

import "./createReserveComponent.vue?vue&type=style&index=0&id=622bb34e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622bb34e"]])

export default __exports__